import React, { lazy, Suspense } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Route, Switch } from 'wouter'
import PageTransition from './ui/PageTransition'
import { getThoughtBySlug } from '@/lib/thoughts'
import { getToolBySlug } from '@/lib/tools'

const Resume = lazy(() => import('./screens/Resume'))
const Photos = lazy(() => import('./screens/Photos'))
const Thoughts = lazy(() => import('./screens/Thoughts'))
const Tools = lazy(() => import('./screens/Tools'))
const About = lazy(() => import('./screens/About'))
const Styleguide = lazy(() => import('./screens/Styleguide'))
const MDXPage = lazy(() => import('./screens/MDXPage'))
const WorkPage = lazy(() => import('./screens/WorkPage'))

function Routes({ onLightboxChange }) {
  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={null}>
        <Switch>
          <Route path="/" />

          <Route path="/resume">
            <PageTransition motionKey="resume">
              <Resume />
            </PageTransition>
          </Route>

          <Route path="/resume/:slug">
            <WorkPage />
          </Route>

          <Route path="/photos">
            <PageTransition motionKey="photos">
              <Photos onLightboxChange={onLightboxChange} />
            </PageTransition>
          </Route>

          <Route path="/thoughts">
            <PageTransition motionKey="thoughts">
              <Thoughts />
            </PageTransition>
          </Route>

          <Route path="/thoughts/:slug">
            <MDXPage type="thoughts" getBySlug={getThoughtBySlug} />
          </Route>

          <Route path="/tools">
            <PageTransition motionKey="tools">
              <Tools />
            </PageTransition>
          </Route>

          <Route path="/tools/:slug">
            <MDXPage type="tools" getBySlug={getToolBySlug} />
          </Route>

          <Route path="/about">
            <PageTransition motionKey="about">
              <About />
            </PageTransition>
          </Route>

          <Route path="/styleguide">
            <PageTransition motionKey="styleguide">
              <Styleguide />
            </PageTransition>
          </Route>
        </Switch>
      </Suspense>
    </AnimatePresence>
  )
}

export default Routes
